import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemsService } from './items-upoad.service';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'items',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './items-upload.component.html',
})
export class ItemsUploadComponent implements OnInit  {
  public error: boolean = false;
  public errorMessage: string = '';
  public showSpinner: boolean = false;
  public selectedFile: File | null = null;
  public uploadProgress: number = 0;
  public uploadSuccess: boolean = false;
  public successMessage: string = '';

  constructor(private itemsService: ItemsService) {
   
  }

  ngOnInit(): void {
    //this.showSpinner = false; 
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      const allowedTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel' // .xls
      ];
      
      if (allowedTypes.includes(file.type)) {
        this.selectedFile = file;
        this.error = false;
        this.errorMessage = '';
        this.uploadSuccess = false;
        this.successMessage = '';
      } else {
        this.error = true;
        this.errorMessage = 'Please select a valid Excel file (.xlsx or .xls)';
        this.selectedFile = null;
      }
    }
  }

  uploadFile(): void {
    if (!this.selectedFile) {
      this.error = true;
      this.errorMessage = 'Please select a file to upload';
      return;
    }

    this.showSpinner = true;
    this.error = false;
    this.errorMessage = '';
    this.uploadSuccess = false;
    this.successMessage = '';
    this.uploadProgress = 0;

    this.itemsService.uploadExcelFile(this.selectedFile).subscribe({
      next: (event) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round(100 * event.loaded / (event.total || 1));
        } else if (event.type === HttpEventType.Response) {
          this.showSpinner = false;
          this.uploadSuccess = true;
          this.successMessage = 'File uploaded successfully!';
          this.selectedFile = null;
          this.uploadProgress = 0;
          // Reset file input
          const fileInput = document.getElementById('fileInput') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }
        }
      },
      error: (error) => {
        this.showSpinner = false;
        this.error = true;
        this.errorMessage = error.error?.message || 'An error occurred while uploading the file';
        this.uploadProgress = 0;
      }
    });
  }

  clearFile(): void {
    this.selectedFile = null;
    this.error = false;
    this.errorMessage = '';
    this.uploadSuccess = false;
    this.successMessage = '';
    this.uploadProgress = 0;
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
}